const id = {
  // Navigation
  'nav.models': 'Model',
  'nav.pricing': 'Harga',
  'nav.docs': 'Dokumen',
  'nav.console': 'Konsol',
  'nav.home': 'Beranda',
  'nav.toggleTheme': 'Ganti tema',
  'nav.langId': 'Bahasa Indonesia',
  'nav.langEn': 'English',

  // Footer
  'footer.tagline':
    'Akses model AI lewat satu endpoint yang kompatibel dengan OpenAI, dengan saldo prabayar dan harga per 1 juta token yang tercantum di katalog.',
  'footer.product': 'PRODUK',
  'footer.legal': 'LEGAL',
  'footer.models': 'Model',
  'footer.pricing': 'Harga',
  'footer.docs': 'Dokumen',
  'footer.changelog': 'Catatan perubahan',
  'footer.terms': 'Syarat dan Ketentuan',
  'footer.privacy': 'Kebijakan Privasi',
  'footer.emailIntro': 'Email ke',
  'footer.rights': 'Semua hak dilindungi.',

  // 404
  'notfound.title': 'Halaman ini tidak tersedia.',
  'notfound.body':
    'Tautan salah atau halaman sudah dipindahkan. Periksa URL, atau kembali ke halaman yang tersedia.',
  'notfound.home': 'Kembali ke beranda',
  'notfound.docs': 'Baca dokumentasi',

  // Login
  'login.welcomeBack': 'SELAMAT DATANG KEMBALI',
  'login.title': 'Masuk ke konsol OpenCSN Anda.',
  'login.subtitle':
    'Kelola API key, pantau pemakaian token, dan lihat biaya per model dalam satu tempat.',
  'login.cardTitle': 'Masuk',
  'login.cardSubtitle': 'Masuk untuk melanjutkan.',
  'login.google': 'Masuk dengan Google',
  'login.or': 'ATAU',
  'login.email': 'Email',
  'login.password': 'Kata sandi',
  'login.submit': 'Masuk',
  'login.noAccount': 'Belum punya akun?',
  'login.signup': 'Daftar',
  'login.forgot': 'Lupa kata sandi?',
  'login.legalNotice': 'Dengan melanjutkan, Anda menyetujui {terms} dan {privacy}.',

  // Register
  'register.title': 'Buat akun',
  'register.subtitle': 'Daftar untuk mulai memakai Layanan.',
  'register.google': 'Daftar dengan Google',
  'register.closed': 'Pendaftaran lewat email sedang ditutup. Gunakan akun Google untuk masuk.',
  'register.haveAccount': 'Sudah punya akun?',
  'register.signin': 'Masuk',
  'register.legalNotice': 'Dengan melanjutkan, Anda menyetujui {terms} dan {privacy}.',

  // Toasts
  'toast.loginRequired': 'Silakan masuk terlebih dahulu untuk mengakses konsol.',
  'toast.devOnly': 'Konsol pengembangan hanya dapat diakses oleh akun developer.',
  'toast.logout': 'Anda telah keluar.',
  'toast.welcome': 'Selamat datang, {name}.',
  'toast.authFailed': 'Otorisasi gagal: {message}',
  'toast.turnstileRequired': 'Selesaikan verifikasi Cloudflare Turnstile terlebih dahulu.',

  // Common
  'common.free': 'Gratis',
  'common.copy': 'Salin',
  'common.copied': 'Tersalin',
  'common.reset': 'Atur ulang',
  'common.all': 'Semua',
  'common.none': 'Kosongkan',

  // Meta
  'meta.home': 'OpenCSN - Gateway API model AI',
  'meta.pricing': 'Harga - OpenCSN',
  'meta.models': 'Model - OpenCSN',
  'meta.docs': 'Dokumentasi - OpenCSN',
  'meta.changelog': 'Catatan perubahan - OpenCSN',
  'meta.login': 'Masuk - OpenCSN',
  'meta.register': 'Daftar - OpenCSN',
  'meta.notfound': 'Halaman tidak ditemukan - OpenCSN',

  // Landing Page
  'landing.heroTitle1': 'Seperti OpenRouter.',
  'landing.heroTitle2': 'Tapi lebih hemat.',
  'landing.heroSubtitle': 'Satu API. Model nyata. Harga lebih hemat. Lebih banyak AI gratis.',
  'landing.getApiKey': 'Dapatkan Kunci API',
  'landing.browseModels': 'Jelajahi model',
  'landing.signup': 'Daftar',
  'landing.featOpenAI': 'Endpoint kompatibel OpenAI',
  'landing.featGateway': 'Gateway terpadu OpenCSN',
  'landing.featConfig': 'Konfigurasi model terpusat',
  'landing.terminalTitle': 'Terminal',
  'landing.providersTitle': 'Kompatibel dengan pemasok dan alat AI utama',
  'landing.agentsTitle': 'Satu gateway untuk semua agen koding',
  'landing.agentsSubtitle': 'Claude Code, Codex, Cursor, atau alat lainnya. Hubungkan ke OpenCSN tanpa mengubah logika aplikasi Anda.',
  'landing.stepsHeading': 'Mulai dalam hitungan menit',
  'landing.stepsTagline': 'Satu kunci, semua model, tanpa konfigurasi rumit.',
  'landing.step1Title': 'Buat akun',
  'landing.step1Desc': 'Daftar akun pengembang. Akses langsung ke konsol dan manajemen API key.',
  'landing.step2Title': 'Tambah saldo',
  'landing.step2Desc': 'Isi saldo prabayar sesuai kebutuhan. Saldo tidak memiliki masa kedaluwarsa.',
  'landing.step2Action': 'Lihat harga',
  'landing.step3Title': 'Kirim panggilan pertama',
  'landing.step3Desc': 'Gunakan SDK OpenAI atau Anthropic langsung mengarah ke endpoint gateway.',
  'landing.step3Action': 'Mulai cepat',
  'landing.faqHeading': 'Pertanyaan yang sering diajukan',
  'landing.faqTagline': 'Informasi teknis dan operasional gateway sebelum menghubungkan ke sistem production Anda.',
  'landing.faqDocs': 'Dokumentasi lengkap',
  'landing.faq1Q': 'Apa itu OpenCSN?',
  'landing.faq1A': 'OpenCSN adalah gateway API multi-model dan konsol operasional untuk akses berbagai penyedia model AI lewat satu endpoint standar.',
  'landing.faq2Q': 'Mengapa menggunakan gateway bukan langsung ke penyedia?',
  'landing.faq2A': 'Integrasi langsung memecah routing, kredensial, dan pencatatan biaya. OpenCSN menyatukan akses dengan satu API key dan saldo prabayar.',
  'landing.faq3Q': 'Apakah prompt atau respons pengguna disimpan?',
  'landing.faq3A': 'Tidak. OpenCSN menerapkan kebijakan Zero Data Retention (ZDR): prompt dan respons tidak disimpan pada basis data maupun log sistem OpenCSN.',
  'landing.faq4Q': 'Bagaimana mekanisme penagihan bekerja?',
  'landing.faq4A': 'Layanan memakai saldo prabayar. Pemotongan saldo dihitung berdasarkan jumlah token nyata yang dipakai pada tarif per 1 juta token di katalog.',
  'landing.faq5Q': 'Apakah format panggilan kompatibel dengan SDK standar?',
  'landing.faq5A': 'Ya. Gateway sepenuhnya kompatibel dengan OpenAI Chat Completions dan Anthropic Messages. Anda cukup mengarahkan baseURL ke OpenCSN.',

  // Pricing Page
  'pricing.title': 'Bayar sesuai pemakaian nyata.',
  'pricing.subtitle': 'Tanpa biaya bulanan minimum dan tanpa komitmen durasi. Isi saldo prabayar dan bayar per token sesuai katalog.',
  'pricing.waysToPay': 'Pilihan pembayaran',
  'pricing.waysToPayDesc': 'Bayar per token atau pilih paket prabayar dengan alokasi pemakaian dan batas laju yang lebih tinggi.',
  'pricing.paygBadge': 'BAYAR SESUAI PEMAKAIAN',
  'pricing.perToken': 'Per token',
  'pricing.paygDesc': 'Saldo dipotong persis sesuai jumlah token yang dipakai pada setiap permintaan.',
  'pricing.createAccount': 'Buat akun',
  'pricing.whatsIncluded': 'FASILITAS TERMASUK',
  'pricing.paygBullet1': 'Akses ke seluruh 28 model AI di katalog',
  'pricing.paygBullet2': 'Termasuk model gratis tanpa biaya per token',
  'pricing.paygBullet3': 'Batas laju standar 60 permintaan per menit',
  'pricing.paygBullet4': 'Saldo prabayar tidak pernah kedaluwarsa',
  'pricing.calcTitle': 'Kalkulator pemakaian saldo',
  'pricing.calcSubtitle': 'Perkiraan jumlah token yang diperoleh berdasarkan anggaran saldo Anda.',
  'pricing.customAmount': 'Nominal saldo kustom (USD)',
  'pricing.topupBtn': 'Isi saldo sekarang',

  // Models Directory & Detail
  'models.title': 'Katalog model AI',
  'models.subtitle': 'Bandingkan model, tarif per 1 juta token masukan dan keluaran, panjang konteks, serta fitur.',
  'models.statModels': 'MODEL',
  'models.statProviders': 'PEMASOK',
  'models.statFree': 'GRATIS',
  'models.filters': 'Filter',
  'models.providers': 'PEMASOK',
  'models.searchProviders': 'Cari pemasok...',
  'models.priceRange': 'RENTANG HARGA',
  'models.allPrices': 'Semua harga',
  'models.freeOnly': 'Hanya gratis',
  'models.under1': 'Di bawah $1/1M',
  'models.1to5': '$1 – $5/1M',
  'models.5to15': '$5 – $15/1M',
  'models.over15': '$15+/1M',
  'models.pricingType': 'TIPE HARGA',
  'models.discounted': 'Diskon',
  'models.searchPlaceholder': 'Cari nama model atau ID...',
  'models.sortBy': 'Urutkan:',
  'models.sortProvider': 'Pemasok (A-Z)',
  'models.sortPriceAsc': 'Harga: Rendah ke Tinggi',
  'models.sortPriceDesc': 'Harga: Tinggi ke Rendah',
  'models.sortName': 'Nama Model (A-Z)',
  'models.sortContext': 'Panjang Konteks',
  'models.viewGrid': 'Grid',
  'models.viewList': 'Tabel',
  'models.thModel': 'MODEL',
  'models.thContext': 'KONTEKS',
  'models.thInput': 'MASUKAN / 1M',
  'models.thOutput': 'KELUARAN / 1M',
  'models.thPerks': 'KEUNGGULAN',
  'models.thActions': 'AKSI',
  'models.detailBack': 'Kembali ke katalog model',
  'models.detailUseModel': 'Gunakan model ini',
  'models.detailCopyId': 'Salin ID',
  'models.detailContext': 'Jendela Konteks',
  'models.detailInputPrice': 'Harga Token Masukan',
  'models.detailOutputPrice': 'Harga Token Keluaran',
  'models.detailCapabilities': 'Kemampuan Model',
  'models.detailVision': 'Penglihatan (Vision)',
  'models.detailReasoning': 'Penalaran (Reasoning)',
  'models.noResults': 'Tidak ada model yang cocok dengan filter pencarian.',

  // Changelog
  'changelog.badge': 'Pembaruan',
  'changelog.title': 'Catatan Rilis & Pembaruan',
  'changelog.subtitle': 'Kronologi penambahan model baru, pembaruan harga token, dan peningkatan gateway.',
  'changelog.tagModel': 'Model Baru',
  'changelog.entry1Title': 'Kimi K3.1 Pro',
  'changelog.entry1Desc': 'Model flagship Kimi K3.1 Pro dari Moonshot AI kini aktif di gateway OpenCSN.',
  'changelog.entry2Title': 'DeepSeek v4.1 Flash Uncensored',
  'changelog.entry2Desc': 'Model DeepSeek v4.1 Flash Uncensored tersedia untuk kebutuhan inferensi cepat tanpa guardrail tambahan.',
  'changelog.entry3Title': 'DeepSeek v4.1 Flash Update 1017',
  'changelog.entry3Desc': 'Build stabil DeepSeek v4.1 Flash versi 1017 diaktifkan otomatis tanpa memerlukan perubahan ID model pada kode Anda.',
  'changelog.entry4Title': 'DeepSeek v4.1 Flash Tier Gratis',
  'changelog.entry4Desc': 'Model DeepSeek v4.1 Flash dapat diakses tanpa biaya pemotongan token saldo selama masa evaluasi.',

  // Forgot Password
  'forgot.title': 'Atur ulang kata sandi',
  'forgot.step1Subtitle': 'Masukkan alamat email akun Anda untuk menerima 6 digit kode verifikasi OTP.',
  'forgot.step2Subtitle': 'Masukkan 6 digit kode OTP dari email Anda dan tentukan kata sandi baru.',
  'forgot.emailLabel': 'Alamat email',
  'forgot.sendBtn': 'Kirim Kode OTP',
  'forgot.changeEmail': 'Ganti email',
  'forgot.otpLabel': 'Kode Verifikasi 6 Digit (OTP)',
  'forgot.newPasswordLabel': 'Kata Sandi Baru',
  'forgot.newPasswordPlaceholder': 'Minimal 6 karakter',
  'forgot.confirmPasswordLabel': 'Konfirmasi Kata Sandi Baru',
  'forgot.confirmPasswordPlaceholder': 'Ulangi kata sandi baru',
  'forgot.submitBtn': 'Perbarui Kata Sandi',
  'forgot.resendOtp': 'Kirim ulang kode OTP',
  'forgot.rememberPassword': 'Ingat kata sandi Anda?',
  'forgot.signin': 'Masuk',

  // Command Palette
  'cmd.overview': 'Ringkasan',
  'cmd.models': 'Model',
  'cmd.usage': 'Pemakaian',
  'cmd.developer': 'Pengembang',
  'cmd.billing': 'Tagihan',
  'cmd.system': 'Sistem',
  'cmd.public': 'Publik',
  'cmd.placeholder': 'Ketik perintah atau cari halaman...',
  'cmd.empty': 'Tidak ada halaman yang cocok dengan "{query}"',
  'cmd.quickNav': 'Navigasi cepat',

  // Docs Navigation
  'docs.badge': 'Dokumentasi',
  'docs.searchPlaceholder': 'Cari dokumentasi...',
  'docs.startHere': 'Mulai di sini',
  'docs.apiReference': 'Referensi API',
  'docs.guides': 'Panduan',
  'docs.backToApp': 'Ke Aplikasi',
  'docs.onThisPage': 'Pada halaman ini',
  'docs.prev': 'Sebelumnya',
  'docs.next': 'Berikutnya',

  // Billing & Redeem
  // API keys
  'keys.neverExpires': 'Tanpa kedaluwarsa',
  'keys.expiresNever': 'Tanpa kedaluwarsa',
  'keys.expires30': '30 hari lagi',
  'keys.expires60': '60 hari lagi',
  'keys.expires90': '90 hari lagi',
  'keys.expires1y': '1 tahun lagi',
  'keys.badgeActive': 'Aktif',
  'keys.badgeBlocked': 'Diblokir',
  'keys.copyTitle': 'Salin API key Anda sekarang',
  'keys.copyOnce': 'Salin {name} di bawah. Secret ini hanya ditampilkan sekali: server hanya menyimpan hash-nya, sehingga tidak bisa ditampilkan lagi.',
  'keys.copy': 'Salin',
  'keys.copyRotateHint': 'Jika hilang, buat key baru atau pakai Rotate: rotasi mengeluarkan secret pengganti dan secret lama berhenti bekerja.',
  'keys.savedCheckbox': 'Saya sudah menyimpan key ini di tempat aman.',
  'keys.done': 'Selesai',
  'keys.rotateTitle': 'Putar (rotate) key ini?',
  'keys.rotateBody': 'Rotate this key? The current secret will stop working immediately and a new one will be issued.',
  'keys.cancel': 'Batal',
  'keys.rotateConfirm': 'Rotate key',
  'keys.newKeyCreatedTitle': 'API key baru dibuat',
  'keys.newKeyWarning': 'Ini satu-satunya saat kunci lengkap ditampilkan. Simpan di tempat yang aman. Kunci lama tidak lagi berfungsi.',
  'keys.savedIt': 'Saya sudah menyimpannya',
  'keys.rotate': 'Rotate',
  'keys.rotateFailed': 'Rotasi gagal.',
  'keys.rotated': 'API key "{name}" dirotasi.',
  'keys.revokeTitle': 'Cabut (revoke) key ini?',
  'keys.revokeBody': '"{name}" langsung berhenti bekerja. Klien yang masih memakainya akan gagal.',
  'keys.revokeConfirm': 'Revoke key',
  'keys.revoke': 'Revoke',
  'keys.revokeFailed': 'Pencabutan gagal.',
  'keys.revoked': 'API key "{name}" dicabut.',
  'keys.pendingRemoteDelete': 'Key dicabut. Penghapusan di gateway masuk antrean dan selesai sebentar lagi.',
  'keys.statusFailed': 'Perubahan status gagal.',
  'keys.block': 'Blokir',
  'keys.unblock': 'Buka blokir',
  'keys.createFailed': 'Pembuatan key gagal.',
  'keys.created': 'API key "{name}" dibuat.',
  'keys.fallbackName': 'Key',
  'billing.enterCode': 'Masukkan kode penukaran voucher.',
  'billing.lowBalanceBanner': 'Saldo Anda menipis ($1.00 atau kurang). Isi ulang saldo agar panggilan API tidak terhenti.',
  'usage.costMismatchTooltip': 'Perkiraan komponen biaya tidak tersedia (menggunakan biaya riil dari gateway).',
  // Dev model management
  'mgmt.importFailed': 'Impor gagal.',
  'mgmt.importDone': '{count} model diimpor.',
  'mgmt.priceRequired': 'Model Active memerlukan harga masukan dan keluaran di atas nol, atau tanda gratis.',
  'mgmt.saveFailed': 'Penyimpanan gagal.',
  'mgmt.nowActive': '{name} kini Active.',
  'mgmt.nowHidden': '{name} kini Hidden.',
  'mgmt.descRestored': 'Deskripsi {name} dipulihkan.',
  'mgmt.discountReset': 'Diskon {name} direset ke 0%.',
  'mgmt.discountApplied': 'Diskon {pct}% diterapkan pada {name}.',
  'mgmt.saved': 'Perubahan {name} tersimpan.',
  'mgmt.emptyCatalog': 'Katalog kosong.',
  'mgmt.emptyCatalogHint': 'Impor dari LiteLLM atau tambahkan model untuk memulai.',
  'mgmt.catalogImport': 'Impor dari LiteLLM',
  'mgmt.statusActive': 'Aktif',
  'mgmt.statusHidden': 'Tersembunyi',
  'mgmt.statusDraft': 'Draf',
  'mgmt.totalModels': 'Total Model',
  'mgmt.publiclyActive': 'Aktif Publik',
  'mgmt.hiddenCount': 'Tersembunyi',
  'mgmt.selectedModel': 'Model Terpilih',
  'mgmt.selectModel': 'Pilih Model AI untuk Dikonfigurasi',
  'mgmt.addModel': 'Tambah Model',
  'mgmt.inLiteLLM': 'Ada di LiteLLM',
  'mgmt.notInLiteLLM': 'Tidak ada di LiteLLM',
  'mgmt.saveChanges': 'Simpan Perubahan',
  'mgmt.deleteModel': 'Hapus Model',
  'mgmt.visibility': 'Visibilitas Akses Publik',
  'mgmt.visibilityActive': 'AKSES PUBLIK: AKTIF',
  'mgmt.visibilityHidden': 'AKSES PUBLIK: TERSEMBUNYI',
  'mgmt.visibilityDraft': 'AKSES PUBLIK: DRAF',
  'mgmt.visibilityHintActive': 'Tampil di katalog publik.',
  'mgmt.visibilityHintHidden': 'Tersembunyi dari katalog publik.',
  'mgmt.visibilityHintDraft': 'Belum terdaftar di LiteLLM.',
  'mgmt.description': 'Deskripsi Model AI',
  'mgmt.restoreDescription': 'Pulihkan Deskripsi Awal',
  'mgmt.livePreview': 'Pratinjau Kartu Langsung',
  'mgmt.noDescription': 'Belum ada deskripsi.',
  'mgmt.pricingBars': 'Bilah Harga Interaktif',
  'mgmt.pricingHint': 'Geser bilah atau pakai kontrol angka per 1 juta token.',
  'mgmt.promos': 'Promo:',
  'mgmt.basePrice': 'Dasar 0%',
  'mgmt.rateInput': 'Tarif Masukan (per 1 juta token)',
  'mgmt.rateCacheRead': 'Tarif Cache Read (per 1 juta token)',
  'mgmt.rateCacheWrite': 'Tarif Cache Write (per 1 juta token)',
  'mgmt.rateOutput': 'Tarif Keluaran (per 1 juta token)',
  'mgmt.distribution': 'Distribusi Harga Relatif (1 juta token)',
  'mgmt.supplierCost': 'Biaya Pemasok',
  'mgmt.supplierCostHint': 'Biaya internal per 1 juta token. Margin tampil per kolom.',
  'mgmt.parameters': 'Parameter Model',
  'mgmt.context': 'Konteks',
  'mgmt.maxOutput': 'Token keluaran maksimum',
  'mgmt.upstreamModel': 'Model upstream',
  'mgmt.badge': 'Badge',
  'mgmt.vision': 'Vision',
  'mgmt.reasoning': 'Reasoning',
  'mgmt.freeModel': 'Model gratis',
  'mgmt.history': 'Riwayat Harga',
  'mgmt.historyRefresh': 'Muat ulang',
  'mgmt.historyEmpty': 'Belum ada perubahan harga tercatat.',
  'mgmt.when': 'Waktu',
  'mgmt.thInput': 'Masukan / 1 juta',
  'mgmt.thOutput': 'Keluaran / 1 juta',
  'mgmt.thCacheRead': 'Cache Read / 1 juta',
  'mgmt.thCacheWrite': 'Cache Write / 1 juta',
  'mgmt.thDiscount': 'Diskon',
  'mgmt.saveParameters': 'Simpan Parameter Model',
  'mgmt.matrix': 'Matriks Model Lengkap',
  'mgmt.matrixHint': 'Ubah visibilitas atau pilih model untuk mengatur harganya.',
  'mgmt.filter': 'Saring model...',
  'mgmt.filterAll': 'Semua ({count})',
  'mgmt.filterActive': 'Aktif ({count})',
  'mgmt.filterHidden': 'Tersembunyi ({count})',
  'mgmt.thModel': 'Model',
  'mgmt.thProvider': 'Pemasok',
  'mgmt.thStatus': 'Status',
  'mgmt.thActions': 'Aksi',
  'mgmt.tune': 'Atur',
  'mgmt.modelId': 'ID Model',
  'mgmt.upstreamModelHint': 'Tulis persis seperti yang dibutuhkan LiteLLM, termasuk prefiks pemasok.',
  'mgmt.cancel': 'Batal',
  'mgmt.create': 'Buat',
  'mgmt.createRequired': 'ID model dan model upstream wajib diisi.',
  'mgmt.createFailed': 'Pembuatan gagal.',
  'mgmt.created': 'Model {id} dibuat.',
  'mgmt.deleteConfirm': 'Hapus {name}? Model juga dihapus dari LiteLLM bila ada.',
  'mgmt.deleteFailed': 'Penghapusan gagal.',
  'mgmt.deleted': 'Model {id} dihapus.',
  'mgmt.freeTier': 'Tingkat Gratis',
  'mgmt.directInput': 'Input langsung:',
  'billing.redeemSuccess': 'Berhasil! Saldo akun Anda telah diperbarui.',
  'catalog.live': 'Tersambung langsung',
  'catalog.stale': 'Koneksi terputus (data lama)',
  'catalog.justNow': 'Baru saja diperbarui',
  'catalog.updatedAgo': 'Diperbarui {seconds} detik lalu',
  'catalog.connecting': 'Menghubungkan...',
  'leaderboard.thSuccessRate': 'Tingkat Berhasil',
  'leaderboard.thAvgLatency': 'Latensi Rata-rata',
};

export default id;
